import jQuery from 'jquery';

export class FaqPresenter {
    constructor () {        
        this.container = $('#faqs');
    }

    render (model) {
        const container = jQuery('#faqs');
        const content = model.Data.map((element) => {
            if (!element.Answer || !element.Question || element.Answer === '' || element.Question === '') {
                return '';
            }
            return this.renderItem(element)
        }).join('')
        container.append(content);          
    }    
    
    renderItem (item) {                
        return `<div class="col-md-6">                            
                <h4 id="faq-${item.FaqId}"><strong>Q.</strong> ${item.Question}</h4>                    
                    ${item.Answer}
                    <div class="line"></div>
                </div>`;
    }    
}